export default __webpack_public_path__ + "static/media/icon_Cast.fcffeda4.png";